export default "__VITE_ASSET__CyXaCwa1__"